import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of } from 'rxjs';
import { firstMemo, memo } from "../util/index.js";
import { erasHistoricApplyAccount } from "./util.js";
export function _ownExposures(instanceId, api) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return memo(instanceId, function (accountId, eras, _withActive) {
    return eras.length ? combineLatest([combineLatest(eras.map(function (e) {
      return api.query.staking.erasStakersClipped(e, accountId);
    })), combineLatest(eras.map(function (e) {
      return api.query.staking.erasStakers(e, accountId);
    }))]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          clp = _ref2[0],
          exp = _ref2[1];

      return eras.map(function (era, index) {
        return {
          clipped: clp[index],
          era: era,
          exposure: exp[index]
        };
      });
    })) : of([]);
  });
}
export var ownExposure = firstMemo(function (api, accountId, era) {
  return api.derive.staking._ownExposures(accountId, [era], true);
});
export var ownExposures = erasHistoricApplyAccount('_ownExposures');